<div class="calendar-month">
  <div class="weekdays">
    <div class="weekend-color">
      <tidy-text class="day-text" [body]="'Sun'" />
    </div>
    <div>
      <tidy-text [body]="'Mon'" />
    </div>
    <div>
      <tidy-text [body]="'Tues'" />
    </div>
    <div>
      <tidy-text [body]="'Wed'" />
    </div>
    <div>
      <tidy-text [body]="'Thu'" />
    </div>
    <div>
      <tidy-text [body]="'Fri'" />
    </div>
    <div class="weekend-color">
      <tidy-text class="day-text" [body]="'Sat'" />
    </div>
  </div>
  <div class="days" [style.--row-count]="cells.length / 7">
    @for (cell of cells; track $index) {
      <div
        [class]="
          (cell.otherMonth ? 'day other-month' : 'day') +
          (cell.isPast ? ' past' : '') +
          (cell.isWeekend ? ' weekend-color weekend-background' : '') +
          (showPricing() && cell.dayState === 'blocked' ? ' blocked' : '') +
          (showPricing() && cell.dayState === 'booked' ? ' booked' : '')"
        (click)="onClickCell(cell)">
        <div class="day-header">
          <div class="price-label">
            @if (showPricing() && cell.data && (cell.available || cell.data.isBooked) && cell.data.price != null) {
              <tidy-text class="price-text" [body]="'$' + (cell.data.price / 100 | number: '1.0-0')" />
            }
          </div>
          <div class="day-label">
            @if (cell.shortMonth) {
              <tidy-text
                style="margin-right: 5px;"
                class="day-text"
                [body]="cell.shortMonth + ' '" />
            }
            @if (cell.isToday) {
              <div class="today-background-container">
                <div class="today-background"></div>
                <tidy-text class="day-text" [body]="cell.dayNum + ''" />
              </div>
            } @else {
              <tidy-text class="day-text" [body]="cell.dayNum + ''" />
            }
          </div>
        </div>
        @if (showPricing() && cell.available && cell.showStayHint && cell.minNights != null) {
          <span class="day-meta">
            <span class="day-meta__inline">
              <tidy-image class="day-meta__icon" [src]="'assets/svg/moon-outline.svg'" />
              @if (cell.maxNights != null) {
                <tidy-text
                  class="day-text day-meta__text day-meta__text--long"
                  [body]="('min ' | translate) + cell.minNights + (' / max ' | translate) + cell.maxNights" />
                <tidy-text
                  class="day-text day-meta__text day-meta__text--short"
                  [body]="cell.minNights + '–' + cell.maxNights" />
              } @else {
                <!-- Real data carries only a min stay — no platform supports a max. -->
                <tidy-text
                  class="day-text day-meta__text day-meta__text--long"
                  [body]="('min ' | translate) + cell.minNights" />
                <tidy-text
                  class="day-text day-meta__text day-meta__text--short"
                  [body]="cell.minNights + '+'" />
              }
            </span>
          </span>
        }
      </div>
    }
  </div>
</div>
